module.exports = __webpack_public_path__ + "img/bath.17110cef.svg";